import { Component, Input, OnInit } from '@angular/core';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';

@Component({
  selector: 'app-depot-iframe',
  templateUrl: './depot-iframe.component.html',
  styleUrls: ['./depot-iframe.component.css']
})
export class DepotIframeComponent implements OnInit {
  constructor(
    public dialogConfig: DialogConfig
  ) {}

  ngOnInit(): void {}

}
